/**
 * 언어별 등록에서 선택된 언어
 */

import { create } from "zustand";

interface SetLangBtn {
  multiLang: string;
  setMultiLang: (btnTyp: string) => void;
  resetMultiLang: () => void;
}

const useMultiLangStore = create<SetLangBtn>((set) => ({
  multiLang: "",

  setMultiLang: (multiLang: string) => {
    set({ multiLang });
  },

  resetMultiLang: () => {
    set({ multiLang: "" });
  },
}));

export default useMultiLangStore;
